import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  title: {
    id: 'app.signup.user.title',
    description: 'App title',
    defaultMessage: 'Are you a manager or an employee?',
  },
  titleRole: {
    id: 'app.signup.user.titleRole',
    description: 'App title',
    defaultMessage: "What's your role in the business?",
  },
  employee: {
    id: 'app.signup.user.employee',
    description: 'The selection button for signup as employee',
    defaultMessage: 'Employee',
  },
  manager: {
    id: 'app.signup.user.manager',
    description: 'The selection button for signup as manager',
    defaultMessage: 'Manager',
  },
  owner: {
    id: 'app.signup.user.owner',
    description: 'The selection button for signup as business owner',
    defaultMessage: 'Business Owner',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_user_type/i18n.js